export default "__VITE_ASSET__86651cdc__"